export const acceptedFileTypes = [
  'pdf',
  'doc',
  'docx',
  'xlsx',
  'csv',
  'txt',
  'png',
  'jpg',
  'jpeg',
  'svg',
  'gif',
  'msg',
  'bmp',
  'ico',
  'html',
  'mp4',
  'webm',
  'mp3',
  'wav',
  'odt',
  'tif',
  'rtf',
  'mov',
  'plan',
  'mht',
  'psd',
  'vsdx',
  'ppt',
  'pptx',
  'webp',
  'eml',
] as const

export type AcceptedFileTypes = (typeof acceptedFileTypes)[number]
